import React, { useEffect } from 'react'
import { ContentEl, LessonEl } from './elements'
import { withStoreProvider } from '../../../../../../../Helpers/withStoreProvider'
import SubmissionsStore from './stores/SubmissionsStore'
import ComponentLoader from '../../../../../../../Components/Loading/ComponentLoader'
import { useParams } from 'react-router-dom'
import CourseStore from '../../../../../Store/CourseStore'
import withStore from '../../../../../../../Components/Unstated/withStore'
import Submissions from './components/contents'
import Header from './components/header'
import Info from './components/info'
import Video from './components/video'
import Review from './components/review'

const ReviewSubmissions = ({
  courseStore: {
    state: { id, chapters },
  },
}) => {
  const { chapterId, lessonId } = useParams()
  const {
    loading,
    loadFailed,
    setCourseId,
    setChapters,
  } = SubmissionsStore.useContainer()

  useEffect(() => {
    if (id) {
      setCourseId(id)
    }
  }, [id, setCourseId])

  useEffect(() => {
    if (chapters) {
      setChapters(chapters)
    }
  }, [chapters, setChapters])

  return (
    <LessonEl key={`${chapterId}-${lessonId}`}>
      <Submissions />
      <ComponentLoader loading={loading} loadFailed={loadFailed}>
        <ContentEl>
          <Header />
          <Info />
          <Video />
          <Review />
        </ContentEl>
      </ComponentLoader>
    </LessonEl>
  )
}

export default withStore([CourseStore])(
  withStoreProvider([SubmissionsStore])(ReviewSubmissions),
)
